import { render } from "./ContactsAddress.vue?vue&type=template&id=71023b16&scoped=true&lang=pug&bindings={\"address\":\"props\",\"data\":\"setup\"}"
import script from "./ContactsAddress.vue?vue&type=script&lang=js"
export * from "./ContactsAddress.vue?vue&type=script&lang=js"

import "./ContactsAddress.vue?vue&type=style&index=0&id=71023b16&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-71023b16"

export default script